"use server";

import { db } from "@/lib/db";
import { hashPassword, verifyPassword } from "@/lib/auth";
import { setSession, deleteSession } from "@/lib/session";
import { redirect } from "next/navigation";
import { revalidatePath } from "next/cache";

export async function login(formData: FormData) {
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;

    const user = await db.user.findUnique({
        where: { email },
        include: { families: { take: 1 } }
    });

    if (!user || !user.passwordHash) {
        return { error: "Invalid email or password" };
    }

    const isValid = await verifyPassword(password, user.passwordHash);
    if (!isValid) {
        return { error: "Invalid email or password" };
    }

    const familyId = user.families[0]?.familyId;
    await setSession(user.id, familyId);
    
    revalidatePath("/");
    return { success: true };
}

export async function register(formData: FormData) {
    const email = formData.get("email") as string;
    const password = formData.get("password") as string;
    const displayName = formData.get("displayName") as string;

    const existing = await db.user.findUnique({ where: { email } });
    if (existing) {
        if (existing.passwordHash === "INVITED") {
            const resolvedPasswordHash = await hashPassword(password);
            await db.user.update({
                where: { email },
                data: {
                    displayName,
                    passwordHash: resolvedPasswordHash
                }
            });
            const userWithFamily = await db.user.findUnique({
                where: { email },
                include: { families: { take: 1 } }
            });
            await setSession(userWithFamily!.id, userWithFamily!.families[0]?.familyId);
            return { success: true };
        } else {
            return { error: "User already exists" };
        }
    }

    const passwordHash = await hashPassword(password);
    const user = await db.user.create({
        data: {
            email,
            passwordHash,
            displayName
        }
    });

    await setSession(user.id);
    return { success: true };
}

export async function logout() {
    await deleteSession();
    redirect("/login");
}
